import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectNotificationsStatus } from '../../fragments/generated/ProjectNotificationsStatus';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectNotificationStatusQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectNotificationStatusQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, notificationsEnabled?: boolean | null } | null } | null };


export const GetProjectNotificationStatus = /*#__PURE__*/ gql`
    query GetProjectNotificationStatus($accountId: ID!, $projectId: ID!) {
  account(by: {id: $accountId}) {
    id
    project(id: $projectId) {
      ...ProjectNotificationsStatus
    }
  }
}
    ${ProjectNotificationsStatus}` as unknown as DocumentNode<GetProjectNotificationStatusQuery, GetProjectNotificationStatusQueryVariables>;

          

          export const useGetProjectNotificationStatusQuery = (options?:QueryHookOptions<GetProjectNotificationStatusQuery, GetProjectNotificationStatusQueryVariables>) => useQuery(GetProjectNotificationStatus, options);

          

          export type GetProjectNotificationStatusQueryOptions = QueryHookOptions<GetProjectNotificationStatusQuery, GetProjectNotificationStatusQueryVariables>;

          

          export const useGetProjectNotificationStatusLazyQuery = (options?:LazyQueryHookOptions<GetProjectNotificationStatusQuery, GetProjectNotificationStatusQueryVariables>) => useLazyQuery(GetProjectNotificationStatus, options);

          

          export type GetProjectNotificationStatusQueryResult = ReturnType<typeof useGetProjectNotificationStatusQuery>;

          
